import React, { useState, useRef, useEffect, useCallback, useMemo, useContext } from 'react';
import { Portal, svgSprite, Tooltip } from '../../../../hybrid/wrappers';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import T, { t } from '../../../../common/components/T';
import uikit from '../../../../project/uikit/styles';
import css from './Actions.module.scss';
import classnames from 'classnames';
import { generateGridStyles } from '../../components/helpers';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import { UserProfileContext } from '../../../../common/utils/getContext';
import { checkBrowser } from '../../../../common/utils/utils';

const WrapperButton = (props) => {
    const ref = useRef();

    useEffect(() => {
        const elem = ref?.current;
        if (elem) {
            const listener = (e) => {
                e.preventDefault();
                if (props.onRightClick) {
                    props.onRightClick();
                }
            };
            elem?.addEventListener('contextmenu', listener);
            return () => {
                elem?.removeEventListener('contextmenu', listener);
            };
        }
    }, [ref.current]);

    if (props.hint) {
        return (
            <div ref={ref} {...props}>
                <Tooltip
                    text={props.hint}
                    compStyle={{
                        inner: {
                            display: 'flex',
                            alignItems: 'center'
                        }
                    }}
                >
                    {props.children}
                </Tooltip>
            </div>
        );
    }
    return (
        <div ref={ref} {...props}>
            {props.children}
        </div>
    );
};
const ModalDropDown = ({ val, showDropdown, modal, refTable, modalDropdown, refTableChild, getHandlers, translation }) => {
    const { officePage } = useContext(UserProfileContext);
    const StylesButton = (button, buttonText) => {
        const defaultdiv = (text) => (
            <div className={css.hover1}>
                <p>{text}</p>
            </div>
        );
        switch (button) {
            case 'download_zip':
                return (
                    <div style={{ display: 'flex' }} className={css.hover2}>
                        <p>{t('button-downloadZip', 'Скачать документы', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'reject':
                return (
                    <div style={{ display: 'flex', color: 'var(--redColor)' }}>
                        <div style={{ marginRight: '8px' }}>
                            {' '}
                            {svgSprite('cross', {
                                className: css.tableButtonIconClosed
                            })}{' '}
                        </div>
                        <p>
                            <T textName='reject' defaultStr='Отклонить' page='all' />
                        </p>
                    </div>
                );
            case 'verify':
                return (
                    <div
                        style={{
                            display: 'flex',
                            color: 'var(--greenDeepColor)'
                        }}
                    >
                        <div style={{ marginRight: '8px' }}>
                            {svgSprite('check', {
                                className: classnames(css.tableButtonIconSmall, css.tableButtonIconNew)
                            })}
                        </div>
                        <p>{t('grid-Verify', 'Верифицировать', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'stages':
                return (
                    <div className={css.optionWithIcon}>
                        {svgSprite('eye')}
                        <p>{t('button-preview', 'Просмотреть', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'transactions':
                return (
                    <div className={css.hover1}>
                        <p>{t('grid-ListFinOperation', 'Список финансовых проводок', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'ban':
                return (
                    <div className={css.hover1}>
                        {val.ban.withdrawal ? (
                            <p>{t('grid-DisallowWithdrawal', 'Запретить вывод', 'widget', translation, 'grid')}</p>
                        ) : (
                            <p>{t('grid-AllowWithdrawal', 'Pазрешить вывод средств', 'widget', translation, 'grid')}</p>
                        )}
                    </div>
                );
            case 'withdrawal':
                return (
                    <div className={css.hover1}>
                        <p>{t('grid-WithdrawFunds', 'Вывести средствa', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'update_volume_in':
                return (
                    <div className={css.hover1}>
                        <p>{t('grid-AddVoluimewFunds', 'Добавить личный объем', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'update_volume_out':
                return (
                    <div className={css.hover1}>
                        <p>{t('grid-RemoveVoluimewFunds', 'Списать личный объем', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'charge_bonus':
                return (
                    <div className={css.hover1}>
                        <p>{t('grid-RemovechargebonusFunds', 'Зачисление бонуса', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'user':
                return (
                    <div className={css.hover1}>
                        <p>{t('grid-WithdrawFunds', 'Вывести средствa', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'transfer':
                return (
                    <div className={css.hover1}>
                        <p>{t('grid-TopUpAccount', 'Пополнить счет', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'show_news_category':
                return defaultdiv(t('grid-NewsAddSubCategory', 'Добавить подкатегорию', 'widget', translation, 'grid'));
            case 'update_news_category':
                return defaultdiv(<T textName='edit' defaultStr='Редактировать' page='all' />);
            case 'destroy_news_category':
                return defaultdiv(<T textName='delete' defaultStr='Удалить' page='all' />);
            case 'block_user':
                return defaultdiv(t('grid-blockingCategory', 'Заблокировать', 'widget', translation, 'grid'));
            case 'unBlock_user':
                return defaultdiv(t('grid-unblockingCategory', 'Разблокировать', 'widget', translation, 'grid'));
            case 'update_user':
                return defaultdiv(<T textName='edit' defaultStr='Редактировать' page='all' />);
            case 'destroy_user':
                return defaultdiv(buttonText?.title || <T textName='delete' defaultStr='Удалить' page='all' />);
            case 'pagemanagement_view':
                return defaultdiv(t('grid-pagemanagement_view', 'Просмотр', 'widget', translation, 'grid'));
            case 'pagemanagement_copy':
                return defaultdiv(t('grid-pagemanagement_copy', 'Дублировать', 'widget', translation, 'grid'));
            case 'pagemanagement_edit':
                return defaultdiv(<T textName='edit' defaultStr='Редактировать' page='all' />);
            case 'pagemanagement_delete':
                return defaultdiv(<T textName='delete' defaultStr='Удалить' page='all' />);
            case 'replenishment':
                return defaultdiv(t('create_user_transfer', 'Создать поступление', 'widget', translation, 'grid'));
            case 'user_transfer':
                return defaultdiv(t('grid-transfer_money', 'Перевод средств', 'widget', translation, 'grid'));
            case 'expense':
                return defaultdiv(t('create_expense', 'Создать расход', 'widget', translation, 'grid'));
            case 'auth_user':
                return defaultdiv(<T textName='auth_user' defaultStr='Авторизоваться под пользователем' page='all' />);
            case 'city_delete':
                return defaultdiv(<T textName='city-delete-action' defaultStr='Удалить' page='all' />);
            case 'city_edit':
                return defaultdiv(<T textName='city-edit-action' defaultStr='Изменить' page='all' />);
            case 'comment':
                return defaultdiv(t('grid-comment', 'Комментарий', 'widget', translation, 'grid'));
            case 'data-post':
                return (
                    <div
                        style={{
                            display: 'flex',
                            color: 'var(--greenDeepColor)'
                        }}
                    >
                        <div style={{ marginRight: '8px' }}>
                            {svgSprite('check', {
                                className: classnames(css.tableButtonIconSmall, css.tableButtonIconNew)
                            })}
                        </div>
                        <p>{t('grid-hold-document', 'Провести документ', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'data-reject':
                return (
                    <div style={{ display: 'flex', color: 'var(--redColor)' }}>
                        <div style={{ marginRight: '8px' }}>
                            {' '}
                            {svgSprite('cross', {
                                className: css.tableButtonIconClosed
                            })}{' '}
                        </div>
                        <p>{t('grid-reject-document', 'Отклонить документ', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'view':
                return (
                    <div className={css.optionWithIcon}>
                        {svgSprite('eye')}
                        <p>{t('button-preview', 'Просмотреть', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'print':
                return (
                    <div className={css.optionWithIcon}>
                        {svgSprite('print-gt')}
                        <p>{t('button-print', 'Печать', 'widget', translation, 'grid')}</p>
                    </div>
                );
            case 'custom':
                return (
                    <div className={css.optionWithIcon}>
                        {buttonText?.icon ? svgSprite(buttonText?.icon) : null}
                        {buttonText?.title ? <p>{buttonText.title}</p> : null}
                    </div>
                );
            case 'delete-with-icon':
                return (
                    <div className={classnames(css.optionWithIcon, css.optionWithIconRed)}>
                        {svgSprite('trash-gt')}
                        <p>
                            <T textName='delete' defaultStr='Удалить' page='all' />
                        </p>
                    </div>
                );
            case 'clear_attempts':
                return defaultdiv(t('grid-clear_attempts', 'Сбросить попытки', 'widget', translation, 'grid'));
            default:
                return typeof buttonText === 'string' ? buttonText : buttonText?.title || button;
        }
    };

    const func = useCallback(() => {
        if (modal?.current) {
            // TODO ZOOM

            const dropDownHeight = modal?.current?.getBoundingClientRect()?.height;
            const dropDownWidth = modal?.current?.getBoundingClientRect()?.width;
            let top = modalDropdown?.current?.getBoundingClientRect()?.top - refTable?.current.getBoundingClientRect()?.top - 10;
            const bottom =
                modalDropdown?.current?.getBoundingClientRect()?.top +
                modalDropdown?.current?.getBoundingClientRect()?.height -
                refTable?.current.getBoundingClientRect()?.top -
                dropDownHeight +
                10;
            let left =
                modalDropdown?.current?.getBoundingClientRect()?.left -
                refTable?.current.getBoundingClientRect()?.left -
                dropDownWidth;
            if (officePage) {
                top =
                    modalDropdown?.current?.getBoundingClientRect()?.top +
                    modalDropdown?.current?.getBoundingClientRect()?.height -
                    refTable?.current.getBoundingClientRect()?.top;
                left =
                    modalDropdown?.current?.getBoundingClientRect()?.right -
                    refTable?.current.getBoundingClientRect()?.left -
                    dropDownWidth;
            }
            const limitBottom = refTableChild?.current.getBoundingClientRect()?.height;
            if (top > limitBottom) {
                modal.current.style.top = `${checkBrowser(bottom)}px`;
            } else {
                modal.current.style.top = `${checkBrowser(top)}px`;
            }
            modal.current.style.left = `${checkBrowser(left)}px`;

            // TODO ZOOM
        }
    }, [modal, modalDropdown, refTable, refTableChild, officePage]);

    useEffect(() => {
        const refTableChildVar = refTableChild?.current;
        func();
        if (refTableChildVar) {
            refTableChildVar.addEventListener('scroll', func);
        }
        return () => {
            refTableChildVar?.removeEventListener('scroll', func);
        };
    }, [func, refTableChild]);

    return (
        <div
            ref={modal}
            style={
                showDropdown
                    ? {
                          position: 'absolute',
                          zIndex: '100000'
                      }
                    : { display: 'none' }
            }
            className={css.modal}
        >
            {val
                ? Object.keys(val)
                      .filter((k) => k !== 'id' && k !== 'settings' && k !== 'commentModal' && k !== 'option')
                      .map((item, index) => {
                          if (item === 'data') {
                              return Object.keys(val?.data).map((el, index) => {
                                  return (
                                      <WrapperButton
                                          key={`ActionBtn_data_${index}`}
                                          {...getHandlers(el)}
                                          style={{
                                              minWidth: '252px',
                                              borderRadius: '8px',
                                              ...uikit.text,
                                              padding: '10px',
                                              cursor: 'pointer'
                                          }}
                                          className={css.hover2}
                                      >
                                          <p> {StylesButton(`data-${el}`)} </p>
                                      </WrapperButton>
                                  );
                              });
                          }
                          return (
                              <WrapperButton
                                  key={`ActionBtn_${index}`}
                                  {...getHandlers(item)}
                                  style={{
                                      minWidth: '252px',
                                      borderRadius: '8px',
                                      ...uikit.text,
                                      padding: '10px',
                                      cursor: 'pointer'
                                  }}
                                  className={classnames(css.hover2, { [css.hover2red]: item?.includes('delete') })}
                              >
                                  <p> {StylesButton(item, val[item])} </p>
                              </WrapperButton>
                          );
                      })
                : null}
        </div>
    );
};
const Actions = ({
    getHandlers,
    val,
    refTable,
    refTableChild,
    gridName,
    translation,
    gridStyles,
    name,
    isFixedLastColumnShow
}) => {
    const { stylers, existCl } = generateGridStyles(gridStyles, name);
    const ref = useRef(false);
    const modal = useRef(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            if (showModal && ref.current && !ref.current.contains(e.target)) {
                setShowModal(false);
            }
        };
        document.addEventListener('click', checkIfClickedOutside);
        document.addEventListener('contextmenu', checkIfClickedOutside);
        return () => {
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [showModal]);
    const isOptions = Object.keys(val).filter((key) => key !== 'id' && key !== 'settings').length;

    const widthDimensions = useWindowDimensions();
    const mobile = useMemo(() => widthDimensions < 768, [widthDimensions]);

    return (
        <div
            ref={ref}
            style={stylers.wrapper}
            className={existCl('wrapper') || classnames(css.flexRow, css.alignItemsCenter, css.justifyContentCenter)}
        >
            {isFixedLastColumnShow && !gridName.endsWith('-last') ? null : !val?.commentModal ? null : mobile ? (
                val?.comment?.modal && val?.comment?.modal?.show ? (
                    <Portal closeHandler={val?.comment?.closeModal}>
                        <val.commentModal val={val} refTableChild={refTableChild} />
                    </Portal>
                ) : null
            ) : (
                <>
                    <val.commentModal val={val} refTableChild={refTableChild} />
                </>
            )}
            {isOptions ? (
                <div
                    onClick={() => {
                        setShowModal((pre) => {
                            return !pre;
                        });
                    }}
                    ref={ref}
                    style={stylers.destroyIcoWrap}
                    className={classnames(
                        css.tableButtonHoverEffect,
                        existCl('destroyIcoWrap') || css.tableButton,
                        existCl('tableButton'),
                        showModal ? css.tableButtonHover : ''
                    )}
                >
                    {svgSprite('dots-horisontal', {
                        style: stylers.updateIco,
                        className: existCl('updateIco') || css.tableButtonIcon
                    })}
                </div>
            ) : null}
            {!!showModal &&
                document.getElementById(`${gridName}portalDropdown`) &&
                ReactDOM.createPortal(
                    <ModalDropDown
                        showDropdown={showModal}
                        modal={modal}
                        refTable={refTable}
                        getHandlers={getHandlers}
                        modalDropdown={ref}
                        val={val}
                        refTableChild={refTableChild}
                        translation={translation}
                    />,
                    document?.getElementById(`${gridName}portalDropdown`)
                )}
        </div>
    );
};
Actions.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
};
export default Actions;
